import { ClientThemeProvider } from '@platform/theme';
import { PropsWithChildren } from 'react';

function hostIsDev(hostname: string): boolean {
  return (
    (hostname.startsWith('portal-interim-home') &&
      hostname.endsWith('.ehyp.dev.interhyp-azure.de')) ||
    hostname === 'home-dev.interhyp.de'
  );
}

function hostIsAcc(hostname: string): boolean {
  return (
    (hostname.startsWith('portal-interim-home') &&
      hostname.endsWith('.ehyp.acc.interhyp-azure.de')) ||
    hostname === 'home-acc.interhyp.de'
  );
}

function hostIsProd(hostname: string): boolean {
  return (
    hostname.startsWith('portal-interim-home') && hostname.endsWith('.ehyp.prod.interhyp-azure.de')
  );
}

/**
 * This function checks if the fqdn is overwritten by the session-storage
 * If not, the location host will be used as fqdn
 */
function getFqdn(): string {
  const { search, host } = window.location;
  const [clientName] = host.split('.');
  const searchParams = new URLSearchParams(search);
  const fqdnOverride = searchParams.get('fqdn') ?? sessionStorage.getItem('fqdn');

  if (fqdnOverride) {
    sessionStorage.setItem('fqdn', fqdnOverride);
    return fqdnOverride;
  }

  if (clientName.startsWith('localhost') || hostIsDev(host)) {
    return 'interhyp.home.ehyptest.interhyp-intern.de';
  }

  if (hostIsAcc(host)) {
    return 'interhyp.home.ehyplivetest.interhyp-intern.de';
  }

  if (hostIsProd(host)) {
    return 'home.interhyp.de';
  }

  return location.host;
}

export function Theme({ children }: PropsWithChildren<{}>): JSX.Element {
  return <ClientThemeProvider fqdn={getFqdn()}>{children}</ClientThemeProvider>;
}
